import type { NavigateFunction } from 'react-router';

import { isSitlSeatPath } from 'components/MapPage/utils/mapExclusiveSurfaces';

/** Open Layers or Events on the incident map (More menu + hamburger share this). */
export function openIncidentMapTab(params: {
  tab: string;
  incidentId: string;
  pathname: string;
  search: string;
  navigate: NavigateFunction;
  setIsMapVisible: (visible: boolean) => void;
}): void {
  const { tab, incidentId, pathname, search, navigate, setIsMapVisible } =
    params;
  setIsMapVisible(true);
  const next = new URLSearchParams(search);
  next.set('openTab', tab);
  if (isSitlSeatPath(pathname)) {
    navigate(`${pathname}?${next.toString()}`);
    return;
  }
  navigate(`/iap/${incidentId}/dashboard?${next.toString()}`);
}
